import { useMemo } from 'react';
import { Stock } from 'components/Stock/Stock.helper';
import { firestore } from "fb";
import { query, collection, where, getDocs } from "firebase/firestore";
import { useQuery } from 'react-query';

export const useStockQuery = (symbol: string) => {
  const country = /\d+/.test(symbol) ? 'kr' : 'us'; // TODO 임시...
  const stockBySymbol = useStocksBySymbol(country);
  return stockBySymbol[symbol];
}

export const useStocksQuery = (country?: string) => {
  let queryResult = useQuery(['stocks', country], () => {
    let ref = query(collection(firestore, "stocks"));

    if(country) {
      ref = query(ref, where('country', '==', country))
    }

    return getDocs(ref);
  });

  const stocks = useMemo(() => {
    if (queryResult.isLoading || !queryResult.data) {
      return [];
    }

    return queryResult.data.docs.map(doc => doc.data() as Stock);
  }, [queryResult.data, queryResult.isLoading]);

  return {
    ...queryResult,
    data: stocks,
  };
};

export type StocksBySymbolOptions = {
  includeIndex: boolean;
};

export const useStocksBySymbol = (country: string, options?: StocksBySymbolOptions) => {
  const { data: originStocks } = useStocksQuery(country);
  const { includeIndex = true } = options || {};

  const stocks = useMemo(() => (
    includeIndex ? originStocks : originStocks.filter(({ sector }) => sector !== 'index')
  ), [includeIndex, originStocks]);

  return useMemo(() => stocks.reduce<Record<string, Stock>>((acc, stock) => {
    acc[stock.symbol] = stock;
    return acc;
  }, {}), [stocks]);
}